import React from 'react'
import styles from './FooterDetails.module.css'

const PrivacyPolicy = () => {
  return (
    <div className={styles.FooterDetails}>
      <h1 className={styles.title}>Privacy Policy</h1>
      <h3 className={styles.heading}>Introduction</h3>
      <p className={styles.body}>
        This Privacy Policy describes how Smartranx Education Center ("the
        Company," "we," "us," or "our") collects, uses, and protects the
        personal information you provide when using our website
        www.smartranx.com ("Website"). We are committed to protecting your
        privacy and ensuring the security of your personal information.
      </p>
      <br />
      <h3 className={styles.heading}>Information Collection</h3>
      <p className={styles.body}>
        <span className={styles.subHeading}>Voluntary Information: </span>
        We undertake not to provide anyone with your contact details, including
        your email ID, unless and until you enter it yourself. However, email
        IDs obtained through our website may be included in our mailing list for
        product/service innovations and relevant news. Recipients of such
        announcements are free to unsubscribe from our mailing lists at any time
        by clicking the “Unsubscribe” link.
      </p>
      <br />
      <p className={styles.body}>
        <span className={styles.subHeading}>Correspondence: </span>We do not
        make any individual or organization privy to the contents of any
        correspondence with us, whether made electronically through this site or
        by conventional means.
      </p>
      <br />
      <p className={styles.body}>
        <span className={styles.subHeading}>Disclosure: </span>Despite the
        above, we reserve the right to disclose any content, records, or
        electronic communication of any kind (including personal information
        transmitted through our site) in certain circumstances, including when
        necessary to operate Smartranx Education Center or protect our property
        and legitimate rights.
      </p>
      <br />
      <h3 className={styles.heading}>Information Security</h3>
      <p className={styles.body}>
        <span className={styles.subHeading}>Control: </span>
        You have total control over the privacy of your information. Your
        information will never be sold, exchanged, or disclosed to any third
        party for marketing purposes.
      </p>
      <br />
      <p className={styles.body}>
        <span className={styles.subHeading}>Opt-in: </span>You can decide
        whether you want to opt-in to receive offers from us.
      </p>
      <br />
      <p className={styles.body}>
        <span className={styles.subHeading}>Payment Information: </span>When
        purchasing our online courses, you may be required to share personal
        information such as name, email address, telephone number, address(es),
        credit card number, expiration, and CVV number. We use Secure Encryption
        Technology (SSL) to process payments, and your credit card information
        is never stored in our system.
      </p>
      <br />
      <h3 className={styles.heading}>Cookie Information</h3>
      <p className={styles.body}>
        Our website uses cookies to enhance your online experience and track
        website performance. Cookies are small text files placed in your
        computer's hard drive and do not identify you personally.
      </p>
      <br />
      <h3 className={styles.heading}>External Links</h3>
      <p className={styles.body}>
        We are not responsible for the privacy policies and information
        practices of third-party websites linked on our site. Please read the
        privacy policies of third-party websites as they may differ from ours.
      </p>
      <br />
      <h3 className={styles.heading}>Course Content</h3>
      <p className={styles.body}>
        Course content provided on our website is for educational and guidance
        purposes only. We reserve the right to modify training content without
        notice.
      </p>
      <br />
      <h3 className={styles.heading}>Copyright Information</h3>
      <p className={styles.body}>
        All material on our website is copyrighted by Smartranx Education Center
        unless otherwise indicated. Written permission must be obtained for any
        use of this material other than for permitted purposes.
      </p>
      <br />
      <h3 className={styles.heading}>Personal Information Policy</h3>
      <p className={styles.body}>
        You can contact us to correct any incorrect or incomplete information we
        hold about you.
      </p>
      <br />
      <h3 className={styles.heading}>Image and Video Capture</h3>
      <p className={styles.body}>
        Images captured during our events should not be misused. Your picture
        may be featured in photos or videos of our classes if you enroll in a
        course.
      </p>
      <br />
      <h3 className={styles.heading}>Sharing Your Personal Information</h3>
      <p className={styles.body}>
        If you authorize us, your testimonial may be displayed on our website or
        social media channels. You can contact us if you do not want your
        pictures/testimonials featured.
      </p>
      <br />
      <h3 className={styles.heading}>Changes to Privacy Policy</h3>
      <p className={styles.body}>
        This privacy policy may change from time to time. Registered users will
        be notified via email when updates occur.
      </p>
      <br />
      <p className={styles.body}>Deleting Personal Information</p>
      <br />
      <p className={styles.body}>
        If you would like to delete your account, please contact us.
      </p>
      <br />
      <p className={styles.body}>Privacy Policy Questions?</p>
      <br />
      <p className={styles.body}>
        If you have any questions regarding our Privacy Policy, please contact
        us.
      </p>
    </div>
  )
}

export default PrivacyPolicy
